import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import ComponentAuthGuard from '@/components/ComponentAuthGuard.vue'
import { userModule } from '@/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'Admin',
  setup(__props) {

const éSecretarioDeInformatica = computed(() => {
	const { currentUser } = userModule
	return !!currentUser && currentUser.role !== 'Visitante' && currentUser.secretarioDeInformatica
})

return { __sfc: true,éSecretarioDeInformatica, ComponentAuthGuard }
}

})